export default function GuidePage( props ) {
	return <div { ...props } />;
}
